module.exports = __webpack_public_path__ + "img/carrousel-arco-digi-3.89508e7a.png";